import apiClient from '../../shared/services/apiClient'

// CRS 规则包管理与版本。错误由调用方用 errMsg() 显示后端 msg
const BASE = '/api/admin/cdn/crs'
const cfg = { skipGlobalErrorToast: true }
const d = (r) => r.data?.data

export const errMsg = (e, fallback = '操作失败') =>
  e?.response?.data?.msg || e?.response?.data?.message || e?.message || fallback

const crsService = {
  releases: () => apiClient.get(`${BASE}/releases`, cfg).then(d),
  build: (tag) => apiClient.post(`${BASE}/build`, { tag }, cfg).then(d),
  getBuild: (id) => apiClient.get(`${BASE}/builds/${id}`, cfg).then(d),
  upstream: (refresh = false) => apiClient.get(`${BASE}/upstream`, { ...cfg, params: refresh ? { refresh: 1 } : {} }).then(d),
  publish: (version) => apiClient.post(`${BASE}/publish`, { version }, cfg).then(d),
  canary: (version, nodeIds) => apiClient.post(`${BASE}/canary`, { version, node_ids: nodeIds }, cfg).then(d),
  unpin: (nodeIds) => apiClient.post(`${BASE}/unpin`, { node_ids: nodeIds }, cfg).then(d),
  rollback: () => apiClient.post(`${BASE}/rollback`, {}, cfg).then(d),
  nodes: () => apiClient.get(`${BASE}/nodes`, cfg).then(d),
  domains: (q) => apiClient.get(`${BASE}/domains`, { ...cfg, params: q ? { q } : {} }).then(d),
  categories: () => apiClient.get(`${BASE}/categories`, cfg).then(d),
  updateDomain: (id, payload) => apiClient.post(`${BASE}/domains/${id}`, payload, cfg).then(d),
}

export default crsService
